import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { NotificationResponse } from '@orion/contracts';
import { api, getPage } from '../../lib/api-client.js';

export function useUnreadCountQuery() {
  return useQuery({
    queryKey: ['notifications-unread-count'],
    queryFn: () => api.get<{ count: number }>('/notifications/unread-count'),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}

export function useNotificationsQuery(unreadOnly: boolean) {
  return useQuery({
    queryKey: ['notifications', unreadOnly],
    queryFn: () => getPage<NotificationResponse[]>(`/notifications?pageSize=50${unreadOnly ? '&unreadOnly=true' : ''}`),
  });
}

function invalidate(queryClient: ReturnType<typeof useQueryClient>) {
  queryClient.invalidateQueries({ queryKey: ['notifications'] });
  queryClient.invalidateQueries({ queryKey: ['notifications-unread-count'] });
}

export function useMarkNotificationRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.patch<NotificationResponse>(`/notifications/${id}/read`),
    onSuccess: () => invalidate(queryClient),
  });
}

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.patch<void>('/notifications/read-all'),
    onSuccess: () => invalidate(queryClient),
  });
}
